<template>
  <div
    v-if="data"
    :class="{ 'main-body': true, padbom: alreadyLogged, paddingtop: isAppEnv }"
    :style="{ backgroundColor: `${data.color}` }"
  >
    <WNavbar
      :nav_title="data.title"
      @mobileLeftBtn="leftBtnClick"
      v-if="!isAppEnv"
    ></WNavbar>
    <img
      :src="data.top_image"
      alt=""
      class="top-icon"
      @click.stop="isLogin(toImgLInk, data.top_link)"
    />
    <div class="content">
      <div v-for="(model, index) in data.display_order" :key="index + 'kk'">
        <!-- 公司 -->
        <div
          data-growing-container
          v-if="
            model.includes('company_infos') &&
            data.company_infos &&
            data.company_infos.image
          "
          @click.stop="isLogin(toImgLInk, data.company_infos.link)"
          class="company-icon"
          :style="{
            backgroundImage: 'url(' + data.company_infos.image + ')',
            backgroundColor: '#fff',
            borderRadius: '12px',
          }"
        >
          <div class="companys">
            <cube-slide :auto-play="false" :allow-vertical="true" allowVertical>
              <cube-slide-item
                v-for="i in Math.ceil(
                  data.company_infos.company_detail_infos.length / 2
                )"
                :key="i"
              >
                <div class="double-companys" data-growing-container>
                  <div
                    data-growing-container
                    :data-growing-idx="i + 50"
                    class="one-company mrl17"
                    @click.stop="
                      isLogin(toCompanyDetail, {
                        token:
                          data.company_infos.company_detail_infos[(i - 1) * 2]
                            .token,
                      })
                    "
                  >
                    <img
                      :src="
                        data.company_infos.company_detail_infos[(i - 1) * 2]
                          .company_logo
                      "
                      alt=""
                    />
                    <p class="company-name">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2]
                          .company_name
                      }}
                    </p>
                    <p class="company-info">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2]
                          .industry_name
                      }}
                    </p>
                    <p class="company-info">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2]
                          .company_scale
                      }}
                    </p>
                  </div>
                  <div
                    data-growing-container
                    :data-growing-idx="i + 60"
                    class="one-company"
                    v-if="
                      data.company_infos.company_detail_infos[
                        (i - 1) * 2 + 1
                      ] !== undefined
                    "
                    @click.stop="
                      isLogin(toCompanyDetail, {
                        token:
                          data.company_infos.company_detail_infos[
                            (i - 1) * 2 + 1
                          ].token,
                      })
                    "
                  >
                    <img
                      :src="
                        data.company_infos.company_detail_infos[(i - 1) * 2 + 1]
                          .company_logo
                      "
                      alt=""
                    />
                    <p class="company-name">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2 + 1]
                          .company_name
                      }}
                    </p>
                    <p class="company-info">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2 + 1]
                          .industry_name
                      }}
                    </p>
                    <p class="company-info">
                      {{
                        data.company_infos.company_detail_infos[(i - 1) * 2 + 1]
                          .company_scale
                      }}
                    </p>
                  </div>
                </div>
              </cube-slide-item>
              <template slot="dots" slot-scope="props">
                <span
                  class="my-dot"
                  :class="{ active: props.current === index }"
                  v-for="(item, index) in props.dots"
                  :key="index"
                  >{{ index + 1 }}</span
                >
              </template>
            </cube-slide>
          </div>
        </div>
        <!-- 公司详情版 -->
        <template
          v-if="
            model.includes('company_job_detail_infos') &&
            data.company_job_detail_infos &&
            data.company_job_detail_infos.image
          "
        >
          <div
            data-growing-container
            @click.stop="isLogin(toImgLInk, data.company_job_detail_infos.link)"
            :style="{
              backgroundImage:
                'url(' + data.company_job_detail_infos.image + ')',
              backgroundColor: '#fff',
              borderRadius: '12px',
            }"
            :class="{
              newcompany: true,
              'h518 slide':
                data.company_job_detail_infos.company_job_detail_infos.length ==
                1,
            }"
          >
            <cube-slide
              class="company-slide"
              :auto-play="false"
              :allow-vertical="true"
            >
              <template
                v-for="(company, index) in data.company_job_detail_infos
                  .company_job_detail_infos"
              >
                <cube-slide-item
                  :class="{ mrL20: index == 0 }"
                  v-if="company.company_info"
                  :key="index + 'ab'"
                  :showDots="false"
                >
                  <div
                    class="newcompany-item"
                    data-growing-container
                    @click.stop="isLogin(toImgLInk, company.link)"
                    :data-growing-idx="index + 80"
                  >
                    <div class="company-flxe">
                      <div class="newcompany-item-top" style="display: flex">
                        <img :src="company.company_info.company_logo" alt="" />
                        <div class="newcompany-top">
                          <p>{{ company.company_info.company_name }}</p>
                          <div class="item-bottom">
                            <span class="info city-info">{{
                              company.company_info.company_city
                            }}</span>
                            <span
                              class="split"
                              v-if="
                                company.company_info.industry_name &&
                                company.company_info.company_city
                              "
                            ></span>
                            <span class="info model-info">{{
                              company.company_info.industry_name
                            }}</span>
                            <span
                              class="split"
                              v-if="
                                company.company_info.company_scale &&
                                company.company_info.company_scale
                              "
                            ></span>
                            <span class="info salary-info">{{
                              company.company_info.company_scale
                            }}</span>
                          </div>
                          <p v-if="company.company_highlights">
                            <img
                              class="good"
                              src="https://files.wondercv.com/campaign-jobs/good.png"
                              alt=""
                            />
                            <span>{{ company.company_highlights }}</span>
                          </p>
                        </div>
                      </div>
                      <div
                        class="newcompany-middle"
                        v-for="(job, sindex) in company.company_jobs"
                        :key="sindex + 'ac'"
                        :data-growing-idx="index * 399 + sindex + 100"
                        data-growing-container
                        @click.stop="
                          isLogin(toJobDetail, { jobtoken: job.token })
                        "
                      >
                        <span>{{ job.job_post }}</span>
                        <span>{{ job.display_salary }}</span>
                      </div>
                      <div class="show-more">
                        查看更多
                        <i class="iconfont iconchevron-right"></i>
                      </div>
                    </div>
                  </div>
                </cube-slide-item>
              </template>
              <template
                slot="dots"
                slot-scope="props"
                v-if="
                  data.company_job_detail_infos.company_job_detail_infos
                    .length > 1
                "
              >
                <span
                  class="my-dot"
                  :class="{ active: props.current === index }"
                  v-for="(item, index) in props.dots"
                  :key="index"
                  >{{ index + 1 }}</span
                >
              </template>
            </cube-slide>
          </div>
        </template>
        <!-- 校招 -->
        <template
          v-if="model.includes('comp_recruit_infos') && data.comp_recruit_infos"
        >
          <div
            data-growing-container
            class="job-icon school-icon"
            v-for="(item, index) in data.comp_recruit_infos"
            @click.stop="isLogin(toImgLInk, item.link)"
            :key="index + 'c'"
            :data-growing-idx="index + 130"
            :style="{
              backgroundImage: 'url(' + item.image + ')',
              backgroundColor: '#fff',
              borderRadius: '12px',
            }"
          >
            <div class="jobs campus">
              <template v-for="(school, sindex) in item.comp_recruit_detail">
                <div
                  class="school"
                  :key="sindex + 'e'"
                  v-if="Object.keys(school).length > 0"
                  :data-growing-idx="index * 499 + sindex + 160"
                  @click.stop="isLogin(toImgLInk, school.comp_recruit_info.url)"
                  data-growing-container
                >
                  <img :src="school.company_logo" alt="" />
                  <div class="school-info">
                    <p>{{ school.comp_recruit_info.comp_name }}</p>
                    <p>{{ school.category }}</p>
                    <p>{{ school.comp_recruit_res | filterTime(that) }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <!-- 职位模块 -->
        <template v-if="model.includes('job_infos') && data.job_infos">
          <div
            v-for="(item, index) in findBlockData(model)"
            :key="index"
            class="job-icon h_772"
            :style="{
              backgroundImage: 'url(' + item.image + ')',
              backgroundColor: '#fff',
              borderRadius: '12px',
            }"
            @click.stop="isLogin(toImgLInk, item.link)"
            data-growing-container
            :data-growing-idx="index + 180"
          >
            <div class="jobs">
              <template v-for="(job, sindex) in item.job_detail_infos">
                <div
                  class="job-item"
                  :key="index * 599 + 210 + sindex"
                  v-if="Object.keys(job).length > 0"
                  @click.stop="
                    isLogin(toJobDetail, {
                      jobtoken: job.token,
                      companytoken: job.company_token,
                    })
                  "
                  data-growing-container
                  :data-growing-idx="index * 599 + 210 + sindex"
                >
                  <div class="item-top">
                    <span class="job-name">{{ job.job_post }}</span>
                    <span>{{ job.display_salary }}</span>
                  </div>
                  <div class="item-middle">
                    <span v-if="job.city_names[0]">{{
                      job.city_names[0]
                    }}</span>
                    <span v-if="job.display_experience">{{
                      job.display_experience
                    }}</span>
                    <span v-if="job.degree_name">{{ job.degree_name }}</span>
                  </div>
                  <div class="item-bottom">
                    <img :src="job.company_logo" alt="" />
                    <span class="info">{{ job.company_nick_name }}</span>
                    <span
                      class="split"
                      v-if="job.company_industry && job.company_name"
                    ></span>
                    <span class="info">{{ job.company_industry }}</span>
                    <span
                      class="split"
                      v-if="job.company_industry && job.company_scale"
                    ></span>
                    <span class="info">{{ job.company_scale }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <!-- 简历 -->
        <template
          v-if="
            model.includes('sample_cv_infos') && data && data.sample_cv_infos
          "
        >
          <div
            class="job-icon"
            v-for="(item, sindex) in findBlockData(model)"
            :key="sindex + 'a'"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
            data-growing-container
            :data-growing-idx="sindex + 240"
          >
            <div
              :class="{
                slide: item.sample_cv_detail_infos.length == 1,
                'job-body': true,
              }"
              @click.stop="isLogin(toImgLInk, item.link)"
            >
              <cube-slide
                :auto-play="false"
                :allow-vertical="true"
                class="resume-slide"
              >
                <cube-slide-item
                  v-for="(resume, index) in item.sample_cv_detail_infos"
                  :key="index + 'b'"
                >
                  <div
                    data-growing-container
                    class="resume"
                    @click.stop="
                      isLogin(resumeLink, {
                        token: resume.token,
                        name: resume.name,
                      })
                    "
                    :data-growing-idx="sindex * 699 + index + 260"
                  >
                    <div class="divDemo">
                      <img style="width: 100%" :src="resume.image" />
                    </div>

                    <div class="resume-demo">
                      <p class="resume-top">{{ resume.name }}</p>
                      <p class="resume-middle">{{ resume.desc | spaceLen }}</p>
                      <p class="line"></p>
                      <div class="resume-detail">
                        查看详情
                        <i class="iconfont iconchevron-right"></i>
                      </div>
                    </div>
                  </div>
                </cube-slide-item>
                <template
                  slot="dots"
                  slot-scope="props"
                  v-if="item.sample_cv_detail_infos.length > 1"
                >
                  <span
                    class="my-dot"
                    :class="{ active: props.current === index }"
                    v-for="(items, index) in props.dots"
                    :key="index + 49"
                    >{{ index + 1 }}</span
                  >
                </template>
              </cube-slide>
            </div>
          </div>
        </template>
        <!-- 横向视频 -->
        <template
          v-if="model.includes('horizontal_videos') && data.horizontal_videos"
        >
          <div
            v-for="(item, index) in findBlockData(model)"
            :key="index"
            class="horization-video-container"
            :style="{
              'background-image': `url(${item.image})`,
            }"
            @click.stop="isLogin(toImgLInk, item.link)"
          >
            <cube-slide
              :auto-play="false"
              :show-dots="false"
              allowVertical
              @change="slideChange($event, item)"
            >
              <cube-slide-item
                v-for="(childItem, childIndex) in item.videoList"
                :key="childIndex"
                class="slide-item"
              >
                <div @click.stop>
                  <VideoItem
                    :src="childItem.video"
                    :poster="childItem.poster"
                    :activeIndex="item.slideIndex"
                  ></VideoItem>
                  <div class="question">{{ childItem.question }}</div>
                  <div class="name">{{ childItem.name }}</div>
                  <div class="desc">{{ childItem.desc }}</div>
                </div>
              </cube-slide-item>
            </cube-slide>
            <div class="dots-content">
              <div
                v-for="(_, index) in item.videoList"
                :key="index"
                class="dot-item"
                :class="{ 'dot-active': index === item.slideIndex }"
              />
            </div>
          </div>
        </template>
        <template
          v-if="model.includes('vertical_videos') && data.vertical_videos"
        >
          <div
            v-for="(item, index) in findBlockData(model)"
            :key="index"
            class="vertical-video-container"
            :style="{
              'background-image': `url(${item.image})`,
            }"
            @click.stop="isLogin(toImgLInk, item.link)"
          >
            <cube-slide
              :auto-play="false"
              :show-dots="false"
              allowVertical
              @change="slideChange($event, item)"
            >
              <cube-slide-item
                v-for="(childItem, childIndex) in item.videoList"
                :key="childIndex"
                class="slide-item"
                @click.stop
              >
                <div class="slide-item-content" @click.stop>
                  <VideoItem
                    :src="childItem.video"
                    :poster="childItem.poster"
                    :activeIndex="item.slideIndex"
                    display-mask
                  ></VideoItem>
                  <div class="user-info-content">
                    <div class="question">{{ childItem.question }}</div>
                    <div class="user-info">
                      <img :src="childItem.avatar" alt="" />
                      <span>{{ childItem.name }}</span>
                      <span>{{ childItem.desc }}</span>
                    </div>
                  </div>
                </div>
              </cube-slide-item>
            </cube-slide>
            <div class="dots-content">
              <div
                v-for="(_, index) in item.videoList"
                :key="index"
                class="dot-item"
                :class="{ 'dot-active': index === item.slideIndex }"
              />
            </div>
          </div>
        </template>
        <!-- 自定义模块 -->
        <template v-if="model.includes('custom') && data.custom_infos">
          <div
            v-for="(item, index) in findBlockData(model)"
            :key="index"
            class="custom-block-container"
            @click.stop="isLogin(toImgLInk, item.link)"
          >
            <img :src="item.image" alt="" />
          </div>
        </template>
        <div
          v-if="
            model.includes('bottom_content') &&
            data.bottom_content &&
            alreadyLogged
          "
          class="bottom-content-container"
        >
          <img
            v-for="(item, index) in data.bottom_content"
            :key="index"
            :src="item.image"
            @click.stop="isLogin(toImgLInk, item.link)"
          />
        </div>
      </div>
      <!-- 活动图 -->
      <template
        v-if="data.activity_infos && data.activity_infos.image"
        data-growing-container
      >
        <img
          :src="data.activity_infos.image"
          alt=""
          class="active-icon"
          @click="isLogin(toImgLInk, data.activity_infos.link)"
        />
      </template>
    </div>
    <div class="footer" v-if="!alreadyLogged && !isAppEnv">
      <img
        src="https://files.wondercv.com/campaign-jobs/m-running.png"
        alt=""
        class="footerIcon"
      />
      <div class="footer-title">
        <p>登录超级简历</p>
        <p>名企精英都在用的简历制作神器</p>
      </div>
      <div class="login" @click="needLogin">登录</div>
    </div>
  </div>
</template>

<script>
// import {data} from './staticData'
import WNavbar from "@/components/global/w-navbar";
import { loginMixin } from "@/assets/js/mixin/global";
import moment from "moment";
import VideoItem from "./components/videoItem.vue";
import { H5InteractionAppMethodNames } from "../../assets/js/constants";
export default {
  mixins: [loginMixin],
  name: "springOffer",
  components: {
    WNavbar,
    VideoItem,
  },
  async created() {
    let res = await this.$api.jobs.getSpringOffer("1", {
      url_suffix: this.$route.params.url,
    });
    if (res.code === 1000) {
      res.data.horizontal_videos.forEach((item) => (item.slideIndex = 0));
      res.data.vertical_videos.forEach((item) => (item.slideIndex = 0));
      this.data = res.data;
    }
    //   this.data = data
  },
  async mounted() {
    await this.loginByWx();
  },
  filters: {
    spaceLen(val) {
      val = val + "";
      return val.length > 38 ? val.substr(0, 38) + "..." : val;
    },
    filterTime(item, vm) {
      if (!item) return "";
      if (!!item.net_apply_end_time) {
        //
        let timeCount =
          parseInt(
            new Date(
              vm
                .moment(item.net_apply_end_time)
                .add(8, "h")
                .format("YYYY-MM-DD")
            ).valueOf() - new Date(vm.moment().format("YYYY-MM-DD")).valueOf()
          ) /
          (24 * 60 * 60 * 1000);
        // console.log(timeCount, moment(item.net_apply_end_time).add(8,'h').format('YYYY-MM-DD HH:MM'), moment().format('YYYY-MM-DD'));
        if (timeCount >= 0 && timeCount <= 30) {
          item.display_time = `网申截止倒计时 ${parseInt(timeCount)} 天`;
        } else {
          item.display_time =
            `截止投递：` +
            vm.moment(item.net_apply_end_time).add(8, "h").format("YYYY-MM-DD");
        }
      } else if (!!item.net_apply_start_time) {
        item.display_time =
          "网申开始：" +
          vm.moment(item.net_apply_start_time).add(8, "h").format("YYYY-MM-DD");
      } else {
        item.display_time =
          "发布时间：" +
          vm.moment(item.created_at).add(8, "h").format("YYYY-MM-DD");
      }
      return item.display_time;
    },
  },
  data() {
    return {
      data: null,
      isAppEnv: !!window.ReactNativeWebView, // true表示app环境，否则false
      that: this,
      moment,
    };
  },
  methods: {
    findBlockData(model) {
      const [name, index] = model.split("#");
      if (index && this.data[name]?.length) {
        return [this.data[name][index - 1]];
      } else {
        return this.data[name];
      }
    },
    leftBtnClick() {
      this.$router.back();
    },
    slideChange(index, data) {
      data.slideIndex = index;
    },
    toSchoolLInk(token) {
      window.location.href = `${process.env.VUE_APP_HOST}/jobs/campus/offers/${token}`;
    },
    toImgLInk(link) {
      if (this.isAppEnv && !!link && !link.includes("company_job")) {
        // link包含company_job 要跳转h5
        let name = "";
        if (link.includes("/jianlimoban/search") && link.includes("?keyword")) {
          name = decodeURIComponent(link.split("?")[1].split("=")[1]);
        }
        let appPageParams = {
          type:
            link.includes("/jianlimoban/search") && link.includes("?keyword")
              ? H5InteractionAppMethodNames.TO_APP_RESUME_PAGE
              : H5InteractionAppMethodNames.TO_APP_SOME_PAGE,
          data:
            link.includes("/jianlimoban/search") && link.includes("?keyword")
              ? { searchKeyword: name }
              : { link },
        };
        this.toAppPage(appPageParams);
        return;
      }
      if (!link) return;
      window.location.href = link;
    },
    toCompanyDetail({ token }) {
      if (this.isAppEnv) {
        let appCompanyDetailParams = {
          type: H5InteractionAppMethodNames.TO_APP_COMPANY_PAGE,
          data: { token },
        };
        this.toAppPage(appCompanyDetailParams);
        return;
      }

      window.location.href = `${process.env.VUE_APP_HOST}/company/${token}.html`;
    },
    toJobDetail({ jobtoken, companytoken }) {
      if (this.isAppEnv) {
        // React Native 环境下
        let appJobDetailParams = {
          type: H5InteractionAppMethodNames.TO_APP_JOB_DETAIL_PAGE,
          data: { jobToken: jobtoken },
        };
        this.toAppPage(appJobDetailParams);
        return;
      }
      // 其他环境
      if (!companytoken) {
        window.location.href = `${process.env.VUE_APP_HOST}/jobs/recommend/${jobtoken}`;
      } else {
        window.location.href = `${process.env.VUE_APP_HOST}/jobs/recommend/${jobtoken}?companyToken=${companytoken}`;
      }
    },
    resumeLink(data) {
      if (this.isAppEnv) {
        // React Native 环境下
        let appJobDetailParams = {
          type: H5InteractionAppMethodNames.TO_APP_RESUME_PAGE,
          data: { searchKeyword: data.name },
        };
        this.toAppPage(appJobDetailParams);
        return;
      }
      window.location.href = data.token
        ? `${process.env.VUE_APP_HOST}/jianlimoban/search?token=${data.token}`
        : data.link;
    },
    // h5 跳转app 页面
    toAppPage(appParams) {
      window.ReactNativeWebView.postMessage(JSON.stringify(appParams));
    },
    isLogin(callback, data) {
      if (this.isAppEnv) {
        // React Native 环境下
        callback(data);
        return;
      }
      // 其他环境
      if (this.alreadyLogged) {
        callback(data);
      } else {
        this.needLogin();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/global/mixin";
@mixin font($color, $size, $weight) {
  color: $color;
  font-size: $size;
  font-weight: $weight;
}
@mixin divsize($w, $h, $r, $color) {
  width: $w;
  height: $h;
  border-radius: $r;
  background: $color;
}
@mixin overmore {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.horization-video-container,
.vertical-video-container {
  position: relative;
  background-color: #fff;
  border-radius: 12px;
  padding-top: 76px;
  padding-bottom: 58px;
  margin-bottom: 24px;
  width: 100%;
  height: 444px;
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  .slide-item {
    padding: 0 20px;
    .video-container {
      width: 100%;
      height: 176px;
      border-radius: 8px;
      overflow: hidden;
    }
    .question {
      color: #1d2129;
      font-weight: bold;
      font-size: 16px;
      margin-top: 20px;
    }
    .name {
      color: #4e5969;
      font-size: 14px;
      margin: 12px 0;
    }
    .desc {
      color: #4e5969;
      line-height: 16px;
      font-size: 14px;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }
  .dots-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 16px;
    display: flex;
    padding: 4px;
    .dot-item {
      width: 6px;
      height: 6px;
      border-radius: 999px;
      background-color: #86909c;
      &:not(:last-child) {
        margin-right: 8px;
      }
      &.dot-active {
        background-color: #ff6644;
      }
    }
  }
}

.vertical-video-container {
  height: 753px;
  .slide-item {
    .slide-item-content {
      position: relative;
      .video-container {
        height: 620px;
      }
      .user-info-content {
        position: absolute;
        bottom: 50px;
        left: 30px;
        z-index: 11;
        .question {
          font-size: 18px;
          color: #fff;
          font-weight: 600;
          white-space: pre-wrap;
          margin-bottom: 12px;
        }
        .user-info {
          padding-right: 30px;
          img {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 8px;
            vertical-align: middle;
          }
          span {
            color: #fff;
            white-space: pre-wrap;
            line-height: 18px;
          }
        }
      }
    }
  }
}

.custom-block-container {
  margin-bottom: 24px;
  img {
    width: 100%;
    object-fit: contain;
    margin: 0 auto;
    cursor: pointer;
    border-radius: 12px;
  }
}

.bottom-content-container {
  position: fixed;
  bottom: 0;
  left: 0;
  @include ipx-footer(0px, 0px);
  width: 100vw;
  overflow: hidden;
  z-index: 999;
  img {
    width: 100%;
  }
}

.mrL20 {
  margin-left: 20px;
}
.h518 {
  height: 518px !important;
}
.good {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.company-flxe {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.company-slide {
  width: 100%;
  height: 333px;
}
.slide {
  /deep/.cube-slide-dots {
    display: none !important;
  }
}
.newcompany {
  width: 344px;
  height: 521px;
  background-size: 100% 100%;
  margin-bottom: 24px;
  padding-top: 100px;
  padding-bottom: 20px;
  box-sizing: border-box;
  .newcompany-item {
    @include divsize(305px, 308px, 8px, #fff);
    padding-top: 18px;
    box-sizing: border-box;
  }
  .newcompany-item-top {
    width: 273px;
    & > img {
      width: 66px;
      height: 66px;
      border-radius: 6px;
      border: 1px solid #ececec;
      margin-right: 12px;
      object-fit: contain;
    }
  }
  .newcompany-top {
    height: 66px;
    width: 190px;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    & > P:nth-of-type(1) {
      max-width: 190px;
      @include overmore();
      @include font(#404040, 18px, 600);
    }
    & > p:nth-of-type(2) {
      display: flex;
      align-items: center;
      @include font(#ff9f00, 12px, 400);
      background-color: rgba(255, 165, 0, 0.08);
      padding: 0 8px;
      padding-left: 0px;
      border-radius: 4px;
      & > span {
        display: inline-block;
        max-width: 160px;
        line-height: 14px;
        @include overmore();
      }
    }
  }
  .newcompany-middle {
    @include divsize(273px, 44px, 4px, #f9f9f9);
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > span:nth-of-type(1) {
      margin-left: 16px;
      max-width: 55%;
      @include overmore();
      @include font(#404040, 14px, 500);
    }
    & > span:nth-of-type(2) {
      margin-right: 16px;
      max-width: 33%;
      @include overmore();
      @include font(#ff6644, 16px, 500);
    }
  }
  .show-more {
    @include font(#ff6644, 14px, 500);
    margin: auto;
    margin-top: 10px;
    display: flex;
    align-items: center;
    & > i {
      font-weight: bold;
    }
  }
}
.padbom {
  padding-bottom: 0px !important;
}
.paddingtop {
  padding-top: 0px !important;
}
.active-icon {
  width: 67px;
  // height: 67px;
  position: fixed;
  top: 450px;
  right: 3px;
  z-index: 10;
  object-fit: cover;
}
.divDemo {
  width: 305px;
  height: 343px;
  display: block;
  overflow: hidden;
  border-radius: 8px 8px 0px 0px;
}
.line {
  border-top: 1px solid #f9f9f9;
}
.resume-slide {
  height: 515px;
}
.resume {
  margin-left: 20px;
  width: 305px;
}
.resume-demo {
  padding: 20px 16px;
  background-color: #ffffff;
  border-radius: 0 0 8px 8px;
  position: relative;
  top: -2px;
  box-shadow: 0px -10px 10px 0px rgba(9, 19, 39, 0.04);
  .resume-top {
    @include font(#404040, 16px, 500);
    @include overmore;
  }
  .resume-middle {
    margin: 8px 0 14px 0;
    width: 100%;
    max-height: 44px;
    white-space: normal;
    overflow: hidden;
    padding-top: 2px;
    line-height: 20px;
    @include font(#9c9c9c, 14px, 400);
  }
  .resume-detail {
    text-align: center;
    margin-top: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    @include font(#ff6644, 14px, 500);
    & > i {
      font-weight: bold;
    }
  }
}
.mrl17 {
  margin-right: 17px;
  margin-left: 17px;
}
.my-dot {
  width: 5px;
  height: 5px;
  background-color: #ffffff;
  opacity: 0.3;
  margin-right: 8px;
  border-radius: 12px;
}
.school-icon {
  height: 684px !important;
}
.school {
  display: flex;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  & > img {
    border: 1px solid #ececec;
    width: 66px;
    height: 66px;
    border-radius: 6px;
    margin-right: 12px;
    object-fit: contain;
  }
  .school-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 195px;

    & > p:nth-child(1) {
      @include overmore;
      @include font(#404040, 18px, 500);
      max-width: 100%;
    }
    & > p:nth-child(2) {
      @include overmore;
      max-width: 100%;
      @include font(#606060, 14px, 400);
    }
    & > p:nth-child(3) {
      @include overmore;
      max-width: 100%;
      padding: 4px 10px;
      @include font(#ff6644, 14px, 400);
      background-color: #fff6f4;
    }
  }
}
.active {
  opacity: 1;
  background-color: #ffffff !important;
}
.main-body {
  // padding-top: 41px;
  // padding-bottom: 34px;
  @include mobile-container(41px, 84px);
  background-color: #f2f3f5;
}
.double-companys {
  display: flex;
  width: 345px;
}
.one-company {
  width: 144px;
  border-radius: 8px;
  background: #ffffff;
  height: 190px;
  box-sizing: border-box;
  padding: 20px 12px 15px 12px;
  text-align: center;

  .company-name {
    text-align: center;
    margin: 12px auto auto auto;
    color: #404040;
    font-weight: 600;
    font-size: 18px;
    height: 25px;
    line-height: 25px;
    margin-bottom: 5px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .company-info {
    width: 100%;
    padding-top: 1px;
    color: #9c9c9c;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  & > img {
    width: 73px;
    height: 73px;
    margin: auto;
    border: 1px solid #ececec;
    border-radius: 6px;
    display: block;
    object-fit: contain;
  }
}
.company-icon {
  width: 345px;
  height: 336px;
  position: relative;
  margin-bottom: 24px;
  background-size: 100% 100%;
}
.companys {
  position: absolute;
  top: 101px;
  left: 3px;
  width: 343px;
  height: 215px;
}
.content {
  padding: 25px 15px 50px;
}
.top-icon {
  width: 375px;
  // height: 380px;
}
.h_772 {
  height: 772px !important;
}
.job-body {
  padding-top: 96px;
  padding-bottom: 87px;
  height: 100%;
  background-color: #fff;
  border-radius: 12px;
}
.job-icon {
  width: 345px;
  height: 692px;
  margin-bottom: 24px;
  background-size: 100% 100%;
  position: relative;
}
.job-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 60%;
  .job-salary {
    max-width: 40%;
  }
}
.jobs {
  position: absolute;
  top: 96px;
  left: 20px;
  width: 305px;
  height: 580px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.campus {
  height: 500px;
}
.job-item {
  height: 118px;
  margin-bottom: 12px;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  .item-top {
    display: flex;
    justify-content: space-between;
    & > span:nth-child(1) {
      line-height: 25px;
      font-weight: 500;
      color: #404040;
      height: 25px;
      font-size: 18px;
    }
    & > span:nth-child(2) {
      line-height: 22px;
      font-weight: 600;
      color: #ff6644;
      height: 22px;
      font-size: 16px;
      letter-spacing: 1px;
    }
  }
  .item-middle {
    margin-top: 6px;
    margin-bottom: 8px;
    & > span {
      height: 23px;
      box-sizing: border-box;
      line-height: 23px;
      padding: 3px 8px;
      margin-right: 6px;
      background-color: #f4f4f4;
      border-radius: 4px;
      opacity: 0.75;
      font-weight: 400;
      color: #606060;
    }
  }
}
.item-bottom {
  display: flex;
  align-items: center;
  width: 100%;
  & > img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
    border-radius: 2px;
    border: 0.5px solid #ececec;
    object-fit: contain;
  }
  .city-info {
    max-width: 25% !important;
  }
  .model-info {
    max-width: 30% !important;
  }
  .salary-info {
    max-width: 40% !important;
  }
  .info {
    display: inline-block;
    font-size: 14px;
    max-width: 33%;
    font-weight: 400;
    color: #606060;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .split {
    height: 9px;
    display: inline-block;
    border-right: 1px solid #cfcfcf;
    margin-right: 6px;
    margin-left: 6px;
  }
}
.footer {
  width: 375px;
  height: 58px;
  position: fixed;
  bottom: 0px;
  // @include fixed-bottom(0px);
  @include ipx-footer(58px, 0px);
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  .footerIcon {
    width: 77px;
    height: 56px;
    position: relative;
    bottom: -3px;
  }
  .footer-title {
    margin: 9px 19px 9px 8px;
    & > p:nth-child(1) {
      line-height: 20px;
      height: 20px;
      color: #ffffff;
      font-weight: 500;
      font-size: 14px;
    }
    & > p:nth-child(2) {
      line-height: 20px;
      height: 20px;
      color: #cfcfcf;
      font-weight: 400;
      font-size: 14px;
    }
  }
  .login {
    width: 60px;
    height: 30px;
    border-radius: 17px;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    position: relative;
    top: 50%;
    margin-top: -15px;
    background: linear-gradient(180deg, #ff9f79 0%, #ff6644 100%);
  }
}
</style>
